import React, { Component } from "react"
import axios from "axios"
import config from "../../../utils/config"
import auth from "../../../utils/auth"
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import Select from "../../../components/Select"
import ConfirmDelete from "../../../components/ConfirmDelete"
import ConfirmarEmailModal from "../../../components/ConfirmarEmailModal"
import { verificarEmailConfirmado } from "../../../services/confirmacaoEmail"

class ModalEmail extends Component {
    userInfo = auth.getUserInfo()
    header = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    state = {
        detalhes: { email_input: "", email_select: null },
        statusModal: false,
        options: [],
        modalConfirmarEmail: { isOpen: false, email: null },
        campoPendente: null
    }
    
    componentDidMount = () => {
        this.getEmails()
    }

    getEmails = () => {
        axios.get(`${config.base_api_url + config.api_v2}/${this.userInfo.empresa}/equipamento/listar/emails/`, this.header)
        .then(({ data }) => {
            const options = [ 
                {
                    label: "Clientes",
                    options: data.emails_clientes.map((item) => ({ label:item, value: item }))
                }, 
                {
                    label: "Usuários",
                    options: data.emails_usuarios.map((item) => ({ label:item, value: item }))
                }
            ]
            this.setState({ options })
        })
    }

    handleChange = (field, value) => {
        const detalhes = { ...this.state.detalhes, [field]: value }
        const span = document.getElementById(`validacao-${field}`)

        if(span) {
            span.innerHTML = ""
        }

        this.setState({ detalhes })
    }

    addEmail = async () => {
        const { email_input, email_select } = this.state.detalhes

        if (email_input) {
            await this.processarEmail(email_input, "email_input")
        }

        if (email_select && email_select.value) {
            await this.processarEmail(email_select.value, "email_select")
        }
    }

    processarEmail = async (email, campo) => {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const emails = this.props.emails

        if (!regexEmail.test(email)) {
            document.getElementById(`validacao-${campo}`).innerHTML = "Digite um e-mail válido!"
            return
        }

        if (emails.some(e => e.email === email)) {
            document.getElementById(`validacao-${campo}`).innerHTML = "Esse e-mail já foi adicionado!"
            return
        }

        try {
            const confirmado = await verificarEmailConfirmado(email)
            if (!confirmado) {
                this.setState({ modalConfirmarEmail: { isOpen: true, email }, campoPendente: campo })
                return
            }
        } catch (error) {
            document.getElementById(`validacao-${campo}`).innerHTML = "Não foi possível verificar este e-mail."
            return
        }

        this.confirmarAdicaoEmail(email, campo)
    }

    confirmarAdicaoEmail = (email, campo) => {
        this.props.setEmails([...this.props.emails, {
            email,
            notificar_consumo_chip: false,
            notificar_sem_comunicacao: false
        }])

        const detalhes = { ...this.state.detalhes }
        if (campo === "email_input") detalhes.email_input = ""
        if (campo === "email_select") detalhes.email_select = null
        this.setState({ detalhes })
    }

    handleEmailConfirmado = (email) => {
        const { campoPendente } = this.state
        this.setState({ modalConfirmarEmail: { isOpen: false, email: null }, campoPendente: null })
        this.confirmarAdicaoEmail(email, campoPendente)
    }

    handleContinuarSemConfirmar = (email) => {
        const { campoPendente } = this.state
        this.setState({ modalConfirmarEmail: { isOpen: false, email: null }, campoPendente: null })
        this.confirmarAdicaoEmail(email, campoPendente)
    }

    deleteEmail = (emailObj) => {
        this.props.setEmails(this.props.emails.filter((e) => e.email !== emailObj.email))
    }

    toggleModal = (status) => {
        this.setState({ statusModal: status })
    }

    handleCheckboxChange = (emailObj, field) => {
        const updatedEmails = this.props.emails.map(e => 
            e.email === emailObj.email ? { ...e, [field]: !e[field] } : e
        )
        this.props.setEmails(updatedEmails)
    }

    render() {
        const { emails, tempo_limite_sem_comunicacao, sim_card } = this.props
        const { statusModal, options, detalhes } = this.state

        return (
            <>
                <Modal className="modal-lg" isOpen={statusModal} toggle={() => this.toggleModal(false)}>
                    <ModalHeader toggle={() => this.toggleModal(false)}>
                        Selecionar e-mails
                    </ModalHeader>
                    <ModalBody>
                        <div className="hdv-form-default">
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="required">Novo e-mail</label>
                                    <input 
                                        type="text" 
                                        value={detalhes.email_input}
                                        onChange={(e) => this.handleChange("email_input", e.target.value)}
                                    />
                                    <span id="validacao-email_input"></span>
                                </div>

                                <div className="col-md-4">
                                    <label className="required">Selecionar e-mail</label>
                                    <Select
                                        value={detalhes.email_select}
                                        options={options}
                                        onChange={(e) => this.handleChange("email_select", e)}
                                    />
                                    <span id="validacao-email_select"></span>
                                </div>

                                <div className="col-md-4" style={{ height: 'fit-content', marginTop: '45px' }}>
                                    <button 
                                        className='hdv-btn-forms hdv-btn-green m-0' 
                                        onClick={this.addEmail} 
                                        style={{ width: "100%" }}
                                    >Selecionar</button> 
                                </div>
                            </div>
                        </div>

                        <table className="table afira-table">
                            <thead>
                                <tr>
                                    <th>E-mail</th>
                                    <th style={{ textAlign: "center" }}>Notificar Consumo Chip</th>
                                    <th style={{ textAlign: "center" }}>Notificar Sem Comunicação</th>
                                    <th style={{ textAlign: "center" }}>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emails.length > 0 ? (
                                    emails.map((emailObj, index) => (
                                        <tr key={index}>
                                            <td>{emailObj.email}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <input
                                                    disabled={sim_card ? false : true}
                                                    type="checkbox"
                                                    checked={emailObj.notificar_consumo_chip}
                                                    onChange={() => this.handleCheckboxChange(emailObj, "notificar_consumo_chip")}
                                                />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <input
                                                    disabled={tempo_limite_sem_comunicacao > 0 ? false : true}
                                                    type="checkbox"
                                                    checked={emailObj.notificar_sem_comunicacao}
                                                    onChange={() => this.handleCheckboxChange(emailObj, "notificar_sem_comunicacao")}
                                                />
                                            </td>
                                            <td className="clean-action" style={{ textAlign: "center" }}>
                                                <ConfirmDelete 
                                                    label="Remover" 
                                                    enabled={true} 
                                                    action={() => this.deleteEmail(emailObj)} 
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" style={{ textAlign: "center" }}>Nenhum e-mail adicionado</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </ModalBody>
                </Modal>
                <div className='col-md-4' style={{ paddingLeft: "0" }}>
                    <button 
                        className='hdv-btn-forms hdv-btn-green' 
                        style={{ width: "100%" }}
                        data-tour="form-emails-selecionar"
                        onClick={() => this.toggleModal(true)}
                    >
                        Selecionar e-mails
                    </button>
                </div>

                <ConfirmarEmailModal
                    isOpen={this.state.modalConfirmarEmail.isOpen}
                    email={this.state.modalConfirmarEmail.email}
                    toggle={() => this.setState({ modalConfirmarEmail: { isOpen: false, email: null }, campoPendente: null })}
                    onConfirmado={this.handleEmailConfirmado}
                    onContinuarSemConfirmar={this.handleContinuarSemConfirmar}
                />
            </>
        )
    }
}

export default ModalEmail
